import React from 'react';

const Cricket = () => {
  return (
    <section className="section-content">
      <h2>Cricket</h2>
      <p>My passion for cricket extends beyond watching the game to analyzing player performance, match strategies, and statistical trends. This section will feature detailed cricket analysis articles exploring various aspects of the sport through a data-driven lens.</p>
    </section>
  );
};

export default Cricket;